import { connect } from 'react-redux';
import LicenseData from './LicenseData';
import { getUpdateLicenseLoader } from '../../../../store/selectors/license.selectors';
import { updateLicenseBegin } from '../../../../store/actions/license.actions';

const mapStateToProps = (state: any) => {
    const isLoading = getUpdateLicenseLoader(state);
    return { isLoading };
};

const mapDispatchToProps = {
    updateLicense: updateLicenseBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(LicenseData);
